import { withRouter } from "react-router";
import { useLocation } from "react-router-dom";
import Page from "components/Page";
import PageBody from "components/PageBody";
import FarmHomePageHead from "./FarmHomePageHead";
import { compose, withAppContext } from "containers/HOC";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import AnalysesPanel from "./AnalysesPanel";

const FarmHome = (props) => {
    const { farm, authContext, refData } = props;
    const referrer = `/app/farm/${farm.id}`;
    const location = useLocation();
    const displayPayment = location.pathname.endsWith("dp");

    const breadcrumb = [{ name: farm.displayName, to: referrer }, { name: "Analyses" }];

    return (
        <Page>
            <FarmHomePageHead farm={farm} authContext={authContext} refData={refData} breadcrumb={breadcrumb} displayPayment={displayPayment} />
            <PageBody>
                <Panel title="Analyses" iconClassName="IconLink--compare" referrer={referrer}>
                    <PanelBody>
                        <AnalysesPanel {...props} />
                    </PanelBody>
                </Panel>
            </PageBody>
        </Page>
    );
};

export default compose(withAppContext, withRouter)(FarmHome);
